import { getUserCognitoGroups } from './auth-groups.util';
import { UserGroup } from './get-group';

/**
 * Acesso às telas exclusivas do Administrador da seguradora (hoje: a trilha de
 * auditoria).
 *
 * É gate por GRUPO, não por permissão: o endpoint `/portal/v1/audit` usa
 * `@RequireGroups('insurer.administrator')` sem `@RequirePermission`, porque
 * não existe permissão de auditoria no token — criar uma custaria redeploy do
 * Lambda de pre-token e renovação do token de todo mundo.
 *
 * Esconder a rota é conveniência; o guard de verdade é o do BFF.
 */
export async function requireAdministratorAccess(): Promise<boolean> {
  const groups = await getUserCognitoGroups();

  return groups.includes(UserGroup.INSURER_ADMINISTRATOR);
}
